// 直播相关请求
import req from './index'

//获取M30直播地址
export const getAirLiveAddress = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.live_address', params)
}

//获取M3直播地址
export const getM3LiveAddress = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.GetDockLiveStatus', params)
}

//获取机场
export const getAirport = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetDockInfo', params)
}

// 直播推流
export const pushFlowLiveAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.LiveStart', params)
}

// 推流后持续更新
export const flowLiveUpdateAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.LiveUpdate', params)
}

// 获取当前执行的管线名称
export const getImplementingPipelineNameAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.getCurLiveRouteName', params)
}

// 获取所有机场信息
export const getAllDockInfoApi = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetDockList', params)
}

// 根据file文件 获取url地址
export const getUrlByFileAPI = (params) => {
  return req.file('api/admin.php?s=Admin.Common.UploadImagesWebTest', params)
}

